// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__xq6+R","popover":"styles_popover__LntkK"};